export const testAbsoluteUrl = (url: string): boolean => {
  return /(^|:)\/\//.test(url);
};
